/* eslint-disable react/prop-types */
import React from 'react';
import ParticipationRate from '../ParticipationRate';

/**
 * Headline metric cards for the Workout Sessions page (034 US1 + US3) on the shared
 * au-card design system. Total Users and Total Records, each with a
 * period-over-period delta (text + icon, never colour alone). Total Users also
 * carries its feature-024 participation rate and the "Subscribed" count.
 */
const ICONS = { up: '▲', down: '▼', flat: '—', new: '★' };
const DELTA_CLASS = { up: 'au-delta--up', down: 'au-delta--down', flat: 'au-delta--flat', new: 'au-delta--flat' };

const Delta = ({ delta }) => {
  if (!delta || !delta.direction) return null;
  const { direction, delta_pct: pct } = delta;
  const pill = direction === 'new'
    ? `${ICONS.new} New`
    : direction === 'flat'
      ? `${ICONS.flat} 0%`
      : `${ICONS[direction]} ${Math.abs(pct)}%`;
  const label = direction === 'new' ? 'this period' : 'vs prior period';
  return (
    <span className="wk-delta" aria-label={`${pill} ${label}`}>
      <span className={`au-delta ${DELTA_CLASS[direction]}`}>{pill}</span>
      <span className="wk-delta__lbl">{label}</span>
    </span>
  );
};

const n = (v) => Number(v || 0).toLocaleString();

const WorkoutSummaryCards = ({
  totalUsers = 0,
  totalRecords = 0,
  totalUserBase = 0,
  subscribedUserCount = 0,
  deltas = {},
}) => (
  <div className="au-cards" data-testid="wk-summary">
    <div className="au-card">
      <span className="au-card__label">Total Users</span>
      <span className="au-card__value tnum">{n(totalUsers)}</span>
      <ParticipationRate className="au-card__sub" count={totalUsers} total={totalUserBase} />
      <span className="au-card__sub" data-testid="wk-subscribed">Subscribed: {n(subscribedUserCount)}</span>
      <Delta delta={deltas.total_users} />
    </div>
    <div className="au-card">
      <span className="au-card__label">Total Records</span>
      <span className="au-card__value tnum">{n(totalRecords)}</span>
      <Delta delta={deltas.total_records} />
    </div>
  </div>
);

export default WorkoutSummaryCards;
